import React from 'react'
import PropTypes from 'prop-types'
import {
  parseISO,
  differenceInSeconds,
  differenceInMinutes,
  differenceInDays,
  differenceInHours,
  differenceInMonths,
  differenceInYears,
} from 'date-fns'
import { FormattedRelativeTime } from 'react-intl'

const getDateRange = date => {
  const now = new Date()
  const buildRange = (value, unit) => ({ value, unit })

  const diffYears = differenceInYears(date, now)
  if (diffYears < 0) return buildRange(diffYears, 'year')

  const diffMonth = differenceInMonths(date, now)
  if (diffMonth < 0) return buildRange(diffMonth, 'month')

  const diffDay = differenceInDays(date, now)
  if (diffDay < 0) return buildRange(diffDay, 'day')

  const diffHour = differenceInHours(date, now)
  if (diffHour < 0) return buildRange(diffHour, 'hour')

  const diffMinute = differenceInMinutes(date, now)
  if (diffMinute < 0) return buildRange(diffMinute, 'minute')

  return buildRange(differenceInSeconds(date, now), 'second')
}

const FormatDateRange = ({ date }) => {
  const { unit, value } = getDateRange(parseISO(date))
  return <FormattedRelativeTime value={value} unit={unit} />
}

FormatDateRange.propTypes = {
  date: PropTypes.string.isRequired,
}

export default FormatDateRange
